import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { leadGenderFilterConfig } from '../../../configs/lead-gender-filter-config';

export const LeadGenderFilter = () => {
  return (
    <InputFilterTrigger
      filterLabel='Gender'
      config={leadGenderFilterConfig}
    />
  );
};
